"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHTML = void 0;
var React = require("react");
exports.parseHTML = function (html, wrap) {
    if (wrap === void 0) { wrap = false; }
    return (React.createElement("span", { dangerouslySetInnerHTML: {
            __html: !html.startsWith("<") && wrap ? "<p>" + html + "</p>" : html
        } }));
};
//# sourceMappingURL=parse-html.js.map